<div class="card">
  @for (category of categories; track category) {
    <div class="mb-3">
      <span class="ps-2 m-1 category-title"> {{ app.getText(category) }} </span>
      @for (field of app.getList(category); track field; let index = $index) {
        <app-field
          [model]="model"
          [field]="field"
          [index]="index"
          [disabled]="app.isLocked(model[getIdKey(category)])"
        ></app-field>
      }
    </div>
  }
</div>
